import Splide from '@splidejs/splide';

var splide = new Splide( '#main-slider', {
  pagination: false,
} );

var thumbnails = document.getElementsByClassName( 'thumbnail' );
var current;

for ( var i = 0; i < thumbnails.length; i++ ) {
  initThumbnail( thumbnails[ i ], i );
}

function initThumbnail( thumbnail, index ) {
  thumbnail.addEventListener( 'click', function () {
    splide.go( index );
  } );
}

splide.on( 'mounted move', function () {
  var thumbnail = thumbnails[ splide.index ];

  if ( thumbnail ) {
    if ( current ) {
      current.classList.remove( 'is-active' );
    }

    thumbnail.classList.add( 'is-active' );
    current = thumbnail;
  }
} );

splide.mount();

var elms = document.getElementsByClassName( 'carousel' );
for ( var i = 0; i < elms.length; i++ ) {
  new Splide(elms[ i ], {
    fixedWidth: 300,
    perPage: 3,
    gap: '10px',
    pagination: false,
    easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
  }).mount();
}